import { render, staticRenderFns } from "./RamsRiskDropdown.vue?vue&type=template&id=7cb44ae6&"
import script from "./RamsRiskDropdown.vue?vue&type=script&lang=js&"
export * from "./RamsRiskDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports